module.exports = __webpack_public_path__ + "static/media/bootstrap.087292cd.svg";